export const GA_ACCOUNT = 'G-JRJHJPYE3R'

export const ANALYTICS__FAILURE = 'analyticsFailure'
export const ANALYTICS__SUCCESS = 'analyticsSuccess'
